import { render, staticRenderFns } from "./RedBook.vue?vue&type=template&id=71a2164f&scoped=true"
import script from "./RedBook.vue?vue&type=script&lang=js"
export * from "./RedBook.vue?vue&type=script&lang=js"
import style0 from "./RedBook.vue?vue&type=style&index=0&id=71a2164f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2164f",
  null
  
)

export default component.exports